// extracted by mini-css-extract-plugin
export default {"wrapper":"lock_wrapper__q+ood","iconLock":"lock_iconLock__SH7VC","tick":"lock_tick__Vj4Op","text":"lock_text__kZbg2","name":"lock_name__ao9kN"};